(() => {
  'use strict';
  const node = document.getElementById('gg-paid-trio-config');
  if (!node || window.ggPaidTrioEvent) return;
  let cfg;
  try { cfg = JSON.parse(node.textContent); } catch { return; }
  const measurement = 'G-0NQTYB5YSJ';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  let ready = false;
  const initialize = () => {
    if (ready || !allowed()) return;
    ready = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', measurement, { send_page_view: false });
    if (![...document.scripts].some(script => script.src.startsWith('https://www.googletagmanager.com/gtag/js'))) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurement;
      document.head.append(script);
    }
  };
  const names = { gg_trio_funnel_view: 'gg_paid_trio_view', gg_trio_funnel_cta: 'gg_paid_trio_cta', gg_trio_quiz_complete: 'gg_paid_trio_quiz_complete', gg_trio_funnel_add_success: 'gg_paid_trio_add_success' };
  window.ggPaidTrioEvent = (event, extra = {}) => {
    if (!allowed() || !['A', 'B'].includes(cfg.arm)) return;
    const qaProbe = event === 'gg_trio_qa_probe' && cfg.qa === true && cfg.qaAssigned === '1';
    if (!qaProbe && (cfg.qaAssigned === '1' || !names[event])) return;
    initialize();
    if (qaProbe) node.dataset.qaProbe = 'queued';
    window.gtag('event', qaProbe ? event : names[event], { send_to: measurement, gg_experiment: 'gg_trio_paid_2026_10', gg_variant: cfg.arm, gg_qa: qaProbe ? '1' : '0', ...extra, ...(qaProbe ? { event_callback: () => { node.dataset.qaProbe = 'processed'; }, event_timeout: 5000 } : {}) });
  };
  document.addEventListener('visitorConsentCollected', () => {
    if (ready) window.gtag('consent', 'update', { analytics_storage: allowed() ? 'granted' : 'denied' });
  });
  if (cfg.qa === true && cfg.qaAssigned === '1' && new URL(location.href).searchParams.get('gg_qa_probe') === '1') {
    const probe = () => window.ggPaidTrioEvent('gg_trio_qa_probe');
    if (window.Shopify?.customerPrivacy) probe();
    else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) probe(); });
  }
})();
